import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateShoppableProductMutationVariables = Types.Exact<{
  shoppableInteractionId: Types.Scalars['ID']['input'];
  input: Types.CreateShoppableProductInput;
}>;


export type CreateShoppableProductMutation = { __typename?: 'RootMutationType', createShoppableProduct?: { __typename?: 'ShoppableProductMutationResult', shoppableProduct?: { __typename?: 'ShoppableProduct', id: string, ctaType: Types.ShoppableProductCtaType, customCtaText?: string | null, product: { __typename?: 'Product', id: string, currencyCode: string, onlineStoreUrl: string, sourceType?: string | null, sourceId?: string | null, title: string, images?: Array<{ __typename?: 'ProductImage', id: string, src?: string | null }> | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const CreateShoppableProductDocument = gql`
    mutation createShoppableProduct($shoppableInteractionId: ID!, $input: CreateShoppableProductInput!) {
  createShoppableProduct(
    shoppableInteractionId: $shoppableInteractionId
    input: $input
  ) {
    shoppableProduct {
      id
      ctaType
      customCtaText
      product {
        id
        currencyCode
        onlineStoreUrl
        sourceType
        sourceId
        title
        images {
          id
          src
        }
        variants {
          id
          originalPrice
          price
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type CreateShoppableProductMutationFn = Apollo.MutationFunction<CreateShoppableProductMutation, CreateShoppableProductMutationVariables>;

/**
 * __useCreateShoppableProductMutation__
 *
 * To run a mutation, you first call `useCreateShoppableProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShoppableProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShoppableProductMutation, { data, loading, error }] = useCreateShoppableProductMutation({
 *   variables: {
 *      shoppableInteractionId: // value for 'shoppableInteractionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShoppableProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateShoppableProductMutation, CreateShoppableProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShoppableProductMutation, CreateShoppableProductMutationVariables>(CreateShoppableProductDocument, options);
      }
export type CreateShoppableProductMutationHookResult = ReturnType<typeof useCreateShoppableProductMutation>;
export type CreateShoppableProductMutationResult = Apollo.MutationResult<CreateShoppableProductMutation>;
export type CreateShoppableProductMutationOptions = Apollo.BaseMutationOptions<CreateShoppableProductMutation, CreateShoppableProductMutationVariables>;